module.exports = __webpack_public_path__ + "static/media/aerlingus.3e85e23c.png";